module.exports = __webpack_public_path__ + "76c434a613ae0b6e08fc3d2e8c244e52.svg";